import React from 'react';
import './style.scss';
import LandingFightAction from './action';
import LandingFightDescription from './description';

const LandingFightSection = () => (
  <section id='gameplay' className='landing-fight-section'>
    <div className='lfs-content'>
      <LandingFightDescription className='lfs-description-wrapper' />
      <LandingFightAction className='lfs-action-wrapper' />
    </div>
  </section>
);

export default LandingFightSection;
